import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=7dae0850&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae0850",
  null
  
)

export default component.exports